import { makeStyles } from "@mui/styles";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PendingStatusView from "../../../../../components/PendingStatusView";
import React, { useCallback } from "react";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles({
  list: {
    listStyle: "none",
    padding: 0
  },
  dialog: {}
});

const CustomerArtworkModal = ({
  isOpen,
  onRequestClose,
  orderProductionJobId
}) => {
  const classes = useStyles();

  const { data, loading, error } = useQuery(query, {
    variables: { orderProductionJobId },
    skip: !isOpen || !orderProductionJobId
  });

  const handleClose = useCallback(() => {
    onRequestClose();
  }, [onRequestClose]);

  return (
    <Dialog
      aria-describedby="Customer Artwork Modal"
      aria-labelledby="Print Area Originals"
      className={classes.dialog}
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
    >
      <DialogTitle>Print Area Originals</DialogTitle>
      <DialogContent>
        {!data ? (
          <PendingStatusView status="Waiting" />
        ) : loading ? (
          <PendingStatusView status="Loading" />
        ) : error ? (
          <Typography variant="body2">
            There was an error while attempting to load customer artwork
          </Typography>
        ) : !data.orderProductionJob ? (
          <Typography variant="body2">
            Unfortunately, that order could not be located
          </Typography>
        ) : (
          <ul className={classes.list}>
            {data.orderProductionJob.customizationAreas.length === 0 ? (
              <Typography variant="body2">No customization areas</Typography>
            ) : (
              data.orderProductionJob.customizationAreas.map(
                ({ id, location, customerArtwork }) => (
                  <li key={id}>
                    <Typography variant="body2">{location}</Typography>
                    {customerArtwork.length === 0 ? (
                      <Typography variant="body2">No artwork</Typography>
                    ) : (
                      <ul className={classes.list}>
                        {customerArtwork.map(({ file, id }) => (
                          <li key={id}>
                            <img
                              alt="Original Artwork"
                              src={file.asset.url.formatted}
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )
              )
            )}
          </ul>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerArtworkModal;
